import axios from 'axios';


export const submitJobApplication = (data) => axios({ method:'POST', url: `/wp-json/tm/v1/jobApplication`, data, headers: { 'X-WP-Nonce': wpApiSettings.nonce } });


export const getJobInfo = (jobId) => axios({ method:'GET', url: `/wp-json/wp/v2/job/${jobId}`, headers: { 'X-WP-Nonce': wpApiSettings.nonce } });